/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import {
  Sidebar,
  Menu,
  MenuItem,
  // SubMenu,
  sidebarClasses,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";
import ilaLogo from "../../../core/assets/images/ila-logo.png";
import coupleImg from "../../../core/assets/images/couple.png";
import waterMark from "../../../core/assets/images/watermark.png";
import { useActiveView } from "../../viewContext";

export default function LoggedInLayout({ component, navImage }) {
  const [toggled, setToggled] = useState(false);
  const { activeView } = useActiveView();
  return (
    <div
      style={{
        display: "flex",
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <Sidebar
        toggled={toggled}
        onBackdropClick={() => setToggled(false)}
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            background: "white",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
        width={"300px"}
        breakPoint="lg"
      >
        <div className="d-flex justify-content-center">
          <img
            src={ilaLogo}
            style={{ width: 100, marginTop: 50, marginBottom: 40 }}
          />
        </div>
        <Menu>
          <MenuItem
            style={{
              borderTop: "1px solid #e5e5e5",
              paddingLeft: 80,
              color: "#8E8E8E",
              fontWeight: "medium",
              fontSize: 21,
            }}
            component={<Link to="/quotations" />}
          >
            Quotations
          </MenuItem>
          <MenuItem
            style={{
              borderTop: "1px solid #e5e5e5",
              paddingLeft: 80,
              color: "#8E8E8E",
              fontWeight: "medium",
              fontSize: 21,
            }}
            component={<Link to="/application" />}
          >
            {" "}
            Applications{" "}
          </MenuItem>
          <MenuItem
            style={{
              borderTop: "1px solid #e5e5e5",
              paddingLeft: 80,
              color: "#8E8E8E",
              fontWeight: "medium",
              fontSize: 21,
            }}
            component={<Link to="/policies" />}
          >
            {" "}
            My Policies{" "}
          </MenuItem>
          {!activeView.loan ? (
            <MenuItem
              style={{
                borderTop: "1px solid #e5e5e5",
                borderBottom: "1px solid #e5e5e5",
                paddingLeft: 80,
                color: "#8E8E8E",
                fontWeight: "medium",
                fontSize: 21,
              }}
              component={<Link to="/accounts" />}
            >
              {" "}
              Accounts
            </MenuItem>
          ) : (
            ""
          )}
        </Menu>
        <div style={{ flex: 1 }} />
        <img
          className="tw-hidden lg:tw-block"
          src={navImage ? navImage : coupleImg}
          style={{ 
            width: "100%", 
            marginTop: "auto",
            minHeight: 0,
            flexShrink: 0
          }}
        />
      </Sidebar>

      <main
        className="flex-grow-1 h-100 "
        style={{
          overflow: "scroll",
          backgroundImage: `url(${waterMark})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "550px",
          backgroundAttachment: "fixed",
          backgroundPositionX: "100%",
          backgroundPositionY: "120%",
        }}
      >
        <div className="container position-relative">
          <span
            style={{
              cursor: "pointer",
              color: "#8e8e8e",
              position: "fixed",
              top: 20,
              left: 20,
              zIndex: 100,
            }}
            role="button"
            className="fa fa-bars fa-2x d-lg-none"
            onClick={() => setToggled(!toggled)}
          >
          </span>
        </div>

        {component}
        <a
          href="https://support.redpearcommunications.com/im_livechat/support/2"
          target="_blank"
          rel="noreferrer"
        >
          <div
            style={{
              borderRadius: 4,
              padding: 20,
              bottom: 20,
              right: 20,
              position: "absolute",
              background: "#bbc543",
              color: "white",
              textDecoration: "none",
              fontStyle: "none",
            }}
            className="d-flex justify-content-center align-content-center"
          >
            <i className="fa fa-comments " aria-hidden="true"></i>
          </div>
        </a>
      </main>
    </div>
  );
}
